<script lang="ts">
  /**
   * 要点（problem-format.md §4、§7）。印（「要点 n」の文字と左の太線）を付けた枠で出し、色だけに頼らない。
   * lesson があれば「基礎に立ち返る」（#/lesson/<id>#<slug>）を添える。href は problemLinkTarget で確かめ直す。
   */
  import { problemLinkTarget } from '../../lib/problems';
  import type { EssentialBlock } from './types';

  interface Props {
    block: EssentialBlock;
    /** 「基礎に立ち返る」を押したとき（戻り先を覚える） */
    onrevisit?: (() => void) | undefined;
  }

  let { block, onrevisit }: Props = $props();

  const href = $derived(
    block.lesson && problemLinkTarget(block.lesson.href)?.lesson ? block.lesson.href : null,
  );
</script>

<aside
  class="essential"
  aria-label="要点 {block.index}"
  data-testid="problem-essential"
  data-index={block.index}
>
  <span class="eyebrow mark"><span aria-hidden="true">◆ </span>要点 {block.index}</span>
  <p class="text">{block.text}</p>
  {#if href}
    <a class="revisit" {href} data-testid="problem-revisit-link" onclick={() => onrevisit?.()}
      >基礎に立ち返る<span aria-hidden="true"> →</span></a
    >
  {/if}
</aside>

<style>
  .essential {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    margin: 0 0 var(--space-3);
    padding: var(--space-3) var(--space-4);
    border: 1px solid var(--border-strong);
    border-left: 4px solid var(--accent);
    border-radius: var(--radius-md);
    background: var(--surface);
  }
  .mark {
    color: var(--accent);
  }
  .text {
    margin: 0;
    font-weight: var(--fw-semibold);
    white-space: pre-line;
  }
  .revisit {
    align-self: flex-start;
    font-size: var(--fs-sm);
    min-height: var(--tap-min);
    display: inline-flex;
    align-items: center;
  }
</style>
